// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import * as MessagesAPI from "./messages.mjs";
import { Messages, } from "./messages.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Conversations extends APIResource {
    constructor() {
        super(...arguments);
        this.messages = new MessagesAPI.Messages(this._client);
    }
    /**
     * Create a new conversation for an agent.
     */
    create(params, options) {
        const { agent_id, ...body } = params;
        return this._client.post('/v1/conversations/', { query: { agent_id }, body, ...options });
    }
    /**
     * Retrieve a specific conversation.
     */
    retrieve(conversationID, options) {
        return this._client.get(path `/v1/conversations/${conversationID}`, options);
    }
    /**
     * Update a conversation.
     */
    update(conversationID, body, options) {
        return this._client.patch(path `/v1/conversations/${conversationID}`, { body, ...options });
    }
    /**
     * List all conversations for an agent (or all conversations if agent_id not
     * provided).
     */
    list(query = {}, options) {
        return this._client.get('/v1/conversations/', { query, ...options });
    }
    /**
     * Delete a conversation.
     *
     * The conversation will no longer appear in list operations.
     */
    delete(conversationID, options) {
        return this._client.delete(path `/v1/conversations/${conversationID}`, options);
    }
    /**
     * Cancel runs associated with a conversation.
     *
     * Note: To cancel active runs, Redis is required.
     *
     * **Agent-direct mode**: Pass conversation_id="default" with agent_id query
     * parameter to cancel runs for the agent's default conversation.
     *
     * **Deprecated**: Passing an agent ID as conversation_id still works but will be
     * removed.
     */
    cancel(conversationID, params = {}, options) {
        const { agent_id } = params ?? {};
        return this._client.post(path `/v1/conversations/${conversationID}/cancel`, {
            query: { agent_id },
            ...options,
        });
    }
    /**
     * Fork an existing conversation.
     *
     * Creates a new conversation that shares the same in-context messages as the
     * source conversation, but with a newly compiled system message reflecting the
     * latest memory block values. The forked conversation belongs to the same agent as
     * the source.
     *
     * If message_id is provided, only source in-context messages up to and including
     * that message are included in the fork.
     *
     * **Agent-direct mode**: Pass conversation_id="default" with agent_id query
     * parameter to fork the agent's default (agent-direct) message history into a new
     * conversation.
     *
     * **Deprecated**: Passing an agent ID as conversation_id still works but will be
     * removed.
     */
    fork(conversationID, params = {}, options) {
        const { agent_id, hidden, message_id } = params ?? {};
        return this._client.post(path `/v1/conversations/${conversationID}/fork`, {
            query: { agent_id, hidden, message_id },
            ...options,
        });
    }
    /**
     * Manually trigger system prompt recompilation for a conversation.
     */
    recompile(conversationID, params = {}, options) {
        const { dry_run, ...body } = params ?? {};
        return this._client.post(path `/v1/conversations/${conversationID}/recompile`, {
            query: { dry_run },
            body,
            ...options,
        });
    }
}
Conversations.Messages = Messages;
//# sourceMappingURL=conversations.mjs.map